import { render } from "./EditAddressModal.vue?vue&type=template&id=46a90bae&scoped=true"
import script from "./EditAddressModal.vue?vue&type=script&lang=js"
export * from "./EditAddressModal.vue?vue&type=script&lang=js"

import "./EditAddressModal.vue?vue&type=style&index=0&id=46a90bae&lang=scss&scoped=true"

import exportComponent from "D:\\a\\_work\\1\\s\\vue-code\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46a90bae"]])

export default __exports__